import { MARKETING, SALES, SERVICE, CMS, OPERATIONS } from './ProductLines';
import { FREE, STARTER, PROFESSIONAL, ENTERPRISE } from './ProductLevels';
import * as BizObjectives from './BizObjectives';
const HighlightedProductsBizObjectives = {
  [MARKETING]: {
    [STARTER]: [BizObjectives.MARKETING_AUTOMATION, BizObjectives.REMOVE_BRANDING_MARKETING, BizObjectives.GET_HELP_FAST, BizObjectives.GROW_YOUR_REVENUE],
    [PROFESSIONAL]: [BizObjectives.AUTOMATE_AND_PERSONALIZE_ENGAGEMENT, BizObjectives.ORCHESTRATE_EFFICIENT_CAMPAIGNS, BizObjectives.OPTIMIZE_CAMPAIGN_CONVERSION, BizObjectives.BUILD_CUSTOM_REPORTS, BizObjectives.ADVANCED_SUPPORT],
    [ENTERPRISE]: [BizObjectives.MANAGE_TEAMS_AND_BRANDS, BizObjectives.EXTEND_PLATFORM, BizObjectives.ADVANCE_YOUR_REPORTING]
  },
  [SALES]: {
    [STARTER]: [BizObjectives.REMOVE_BRANDING_SALES, BizObjectives.STREAMLINE_B2B_BUYING, BizObjectives.ORGANIZE_YOUR_SALES_PROCESS, BizObjectives.OPERATE_WITH_EASE_SALES, BizObjectives.GET_HELP_FAST],
    [PROFESSIONAL]: [BizObjectives.MANAGE_GROWING_TEAM, BizObjectives.PERSONALIZE_OUTREACH, BizObjectives.CONFIGURE_PRICE_QUOTE, BizObjectives.ADVANCED_SUPPORT],
    [ENTERPRISE]: [BizObjectives.CUSTOMIZE_TO_MATCH_YOUR_BUSINESS, BizObjectives.EXTEND_ADMINISTRATIVE_CONTROLS, BizObjectives.COACH_AND_ENABLE]
  },
  [SERVICE]: {
    [STARTER]: [BizObjectives.REMOVE_BRANDING_SERVICE, BizObjectives.ORGANIZE_SUPPORT_CHANNELS, BizObjectives.STREAMLINE_CUSTOMER_COMMUNICATIONS, BizObjectives.IMPROVE_RETENTION, BizObjectives.GET_HELP_FAST, BizObjectives.GROW_YOUR_REVENUE],
    [PROFESSIONAL]: [BizObjectives.SCALE_SUPPORT, BizObjectives.CONNECT_SERVICE_TO_FRONT_OFFICE, BizObjectives.EXPAND_CUSTOMER_RELATIONSHIPS, BizObjectives.ADVANCED_SUPPORT],
    [ENTERPRISE]: [BizObjectives.MANAGE_SCALING_TEAMS, BizObjectives.CUSTOMIZE_YOUR_PROCESS, BizObjectives.OPTIMIZE_PERFORMANCE]
  },
  [CMS]: {
    [STARTER]: [BizObjectives.SECURE_YOUR_WEBSITE, BizObjectives.BUILD_EFFICIENTLY, BizObjectives.LEVERAGE_FULL_PLATFORM, BizObjectives.GROW_YOUR_REVENUE],
    [PROFESSIONAL]: [BizObjectives.PERSONALIZE_CUSTOMER_EXPERIENCES, BizObjectives.OPTIMIZE_YOUR_WEBSITE, BizObjectives.EXPAND_CONTENT_STRATEGY],
    [ENTERPRISE]: [BizObjectives.BUILD_POWERFUL_DIGITAL_EXPERIENCES, BizObjectives.MANAGE_GROWING_TEAM_AND_BRAND, BizObjectives.EXTEND_DIGITAL_PRESENCE]
  },
  [OPERATIONS]: {
    [STARTER]: [BizObjectives.CONNECT_TOOLS_AND_SYNC_CUSTOMER_DATA, BizObjectives.ORGANIZE_YOUR_OPERATIONS_EFFORTS, BizObjectives.GET_HELP_FAST, BizObjectives.GROW_YOUR_REVENUE],
    [PROFESSIONAL]: [BizObjectives.AUTOMATE_BUSINESS_PROCESSES, BizObjectives.MONITOR_AND_CLEAN_DATA, BizObjectives.MANAGE_SCALING_BUSINESS, BizObjectives.OPERATIONS_BUILD_CUSTOM_REPORTS],
    [ENTERPRISE]: [BizObjectives.CURATE_AND_MANAGE_DATA_WITH_EASE, BizObjectives.CUSTOMIZE_AND_EXTEND_THE_PLATFORM]
  },
  [`${MARKETING}_MON607`]: {
    [STARTER]: {
      branding: [BizObjectives.REMOVE_BRANDING_MARKETING_MON607],
      regular: [BizObjectives.GET_HELP_FAST_MON607]
    },
    [PROFESSIONAL]: {
      regular: [BizObjectives.AUTOMATE_AND_PERSONALIZE_ENGAGEMENT_MON607, BizObjectives.ORCHESTRATE_EFFICIENT_CAMPAIGNS_MON607, BizObjectives.BUILD_CUSTOM_REPORTS_MON607]
    },
    [ENTERPRISE]: {
      regular: [BizObjectives.MANAGE_TEAMS_AND_BRANDS_MON607, BizObjectives.EXTEND_PLATFORM_MON607, BizObjectives.ADVANCE_YOUR_REPORTING_MON607]
    }
  },
  [`${SALES}_MON607`]: {
    [STARTER]: {
      regular: [BizObjectives.ORGANIZE_YOUR_SALES_PROCESS_MON607, BizObjectives.OPERATE_WITH_EASE_SALES_MON607]
    },
    [PROFESSIONAL]: {
      regular: [BizObjectives.MANAGE_GROWING_TEAM_MON607, BizObjectives.PERSONALIZE_OUTREACH_MON607, BizObjectives.CONFIGURE_PRICE_QUOTE_MON607]
    },
    [ENTERPRISE]: {
      regular: [BizObjectives.CUSTOMIZE_TO_MATCH_YOUR_BUSINESS_MON607, BizObjectives.EXTEND_ADMINISTRATIVE_CONTROLS_MON607, BizObjectives.COACH_AND_ENABLE_MON607]
    }
  },
  [`${SERVICE}_MON607`]: {
    [STARTER]: {
      branding: [BizObjectives.REMOVE_BRANDING_SERVICE_MON607],
      regular: [BizObjectives.ORGANIZE_SUPPORT_CHANNELS_MON607, BizObjectives.GET_HELP_FAST_MON607]
    },
    [PROFESSIONAL]: {
      regular: [BizObjectives.SCALE_SUPPORT_MON607, BizObjectives.EXPAND_CUSTOMER_RELATIONSHIPS_MON607, BizObjectives.ADVANCED_SUPPORT_MON607]
    },
    [ENTERPRISE]: {
      regular: [BizObjectives.MANAGE_SCALING_TEAMS_MON607, BizObjectives.CUSTOMIZE_YOUR_PROCESS_MON607, BizObjectives.OPTIMIZE_PERFORMANCE_MON607]
    }
  },
  [`${CMS}_MON607`]: {
    [STARTER]: {
      regular: [BizObjectives.SECURE_YOUR_WEBSITE_MON607, BizObjectives.BUILD_EFFICIENTLY_MON607]
    },
    [PROFESSIONAL]: {
      regular: [BizObjectives.PERSONALIZE_CUSTOMER_EXPERIENCES_MON607, BizObjectives.OPTIMIZE_YOUR_WEBSITE_MON607, BizObjectives.EXPAND_CONTENT_STRATEGY_MON607]
    },
    [ENTERPRISE]: {
      regular: [BizObjectives.BUILD_POWERFUL_DIGITAL_EXPERIENCES_MON607, BizObjectives.EXTEND_DIGITAL_PRESENCE_MON607]
    }
  },
  [`${OPERATIONS}_MON607`]: {
    [FREE]: {
      regular: [BizObjectives.TRANSFER_DATA_FAST_MON607, BizObjectives.CONNECT_THIRD_PARTY_APPS_MON607, BizObjectives.TRACK_EMAIL_EFFORTS_MON607]
    },
    [STARTER]: {
      regular: [BizObjectives.CONNECT_TOOLS_AND_SYNC_CUSTOMER_DATA_MON607, BizObjectives.ORGANIZE_YOUR_OPERATIONS_PROCESS_MON607, BizObjectives.GET_HELP_FAST_MON607]
    },
    [PROFESSIONAL]: {
      regular: [BizObjectives.AUTOMATE_BUSINESS_PROCESSES_MON607, BizObjectives.CLEAN_CUSTOMER_DATA_MON607, BizObjectives.OPERATIONS_BUILD_CUSTOM_REPORTS_MON607]
    }
  }
};
export default HighlightedProductsBizObjectives;